export default __webpack_public_path__ + "static/media/prize2.d709e8e4.svg";